import {
  FaCar,
  FaTicketAlt,
  FaSuitcase,
  FaBus,
  FaUtensils,
  FaCoffee,
  FaPassport,
  FaShip,
  FaShoppingBag,
  FaTrain,
  FaGlobeAmericas,
  FaMap,
  FaMapSigns,
  FaTaxi,
  FaTag,
  FaCheckCircle,
  FaIdCard,
  FaComment,
  FaGolfBall,
  FaSkiing,
  FaSignLanguage,
} from 'react-icons/fa';
import { RiHotelFill } from 'react-icons/ri';
import { MdMedicalServices } from 'react-icons/md';
import { ImAirplane } from 'react-icons/im';

export const ICON_MAPPING = {
  'fa fa-bed': RiHotelFill,
  'fa fa-ticket-alt': FaTicketAlt,
  'fa fa-suitcase': FaSuitcase,
  'fa fa-plane': ImAirplane,
  'fa fa-car': FaCar,
  'fa fa-medkit': MdMedicalServices,
  'fa fa-bus': FaBus,
  'fa fa-utensils': FaUtensils,
  'fa fa-coffee': FaCoffee,
  'fa fa-passport': FaPassport,
  'fa fa-ship': FaShip,
  'fa fa-shopping-bag': FaShoppingBag,
  'fa fa-train': FaTrain,
  'fa fa-globe-americas': FaGlobeAmericas,
  'fa fa-map': FaMap,
  'fa fa-map-signs': FaMapSigns,
  'fa fa-taxi': FaTaxi,
  'fa fa-tag': FaTag,
  'fa fa-check-circle': FaCheckCircle,
  'fa fa-american-sign-language-interpreting': FaSignLanguage,
  'fa fa-id-card': FaIdCard,
  'fa fa-comment': FaComment,
  'fa fa-golf-ball': FaGolfBall,
  'fa fa-skiing': FaSkiing,
};

// Mapeo de códigos a descripciones oficiales de la base de datos
export const ICON_DESCRIPTIONS = {
  'fa fa-bed': 'Hotels',
  'fa fa-medkit': 'Insurance',
  'fa fa-bus': 'Bus',
  'fa fa-ticket-alt': 'Activities',
  'fa fa-plane': 'Flights',
  'fa fa-utensils': 'Full Board',
  'fa fa-coffee': 'Breakfast',
  'fa fa-passport': 'Passport',
  'fa fa-ship': 'Cruise',
  'fa fa-shopping-bag': 'Shopping Day',
  'fa fa-car': 'Transfer',
  'fa fa-train': 'Train',
  'fa fa-globe-americas': 'World',
  'fa fa-map': 'Map',
  'fa fa-map-signs': 'Signs',
  'fa fa-taxi': 'Taxi',
  'fa fa-tag': 'Tag',
  'fa fa-check-circle': 'Check',
  'fa fa-american-sign-language-interpreting': 'Sign Language',
  'fa fa-id-card': 'Visa',
  'fa fa-comment': 'Tour Guide',
  'fa fa-golf-ball': 'Golf',
  'fa fa-suitcase': 'Packages',
  'fa fa-skiing': 'Ski',
};
